import axios from "axios";

// axios.defaults.baseURL = 'http://127.0.0.1:8000/api'
axios.defaults.baseURL = 'https://storage-api.appmobiplus.com/api'
axios.defaults.withCredentials = false

export default axios